module.exports = __webpack_public_path__ + "static/media/bluetooth.8ba6162b.svg";